/** Momento del día que pinta el cielo y el agua del puerto. */
export type Momento = 'amanecer' | 'dia' | 'atardecer' | 'noche';

type Paleta = {
  cielo: [string, string];
  agua: [string, string];
  titulo: string;
  subtitulo: string;
  /** Sol o luna. */
  astro: 'sol' | 'luna';
  colorSol: string;
  estrellas: number;
  nubes: boolean;
  /** Farolillos encendidos en los barcos. */
  luces: boolean;
};

/** Amanecer de 7 a 9, día hasta las 18:30, atardecer hasta las 21 y noche el resto. */
export function momentoDelDia(fecha: Date): Momento {
  const hora = fecha.getHours() + fecha.getMinutes() / 60;
  if (hora >= 7 && hora < 9) {
    return 'amanecer';
  }
  if (hora >= 9 && hora < 18.5) {
    return 'dia';
  }
  if (hora >= 18.5 && hora < 21) {
    return 'atardecer';
  }
  return 'noche';
}

export const PALETAS: Record<Momento, Paleta> = {
  amanecer: {
    cielo: ['#3b4a7a', '#f2a37a'],
    agua: ['#2f6a78', '#16303f'],
    titulo: '#fff4e8',
    subtitulo: '#f6dcc8',
    astro: 'sol',
    colorSol: '#ffb38a',
    estrellas: 0.25,
    nubes: true,
    luces: false,
  },
  dia: {
    cielo: ['#3a86c8', '#8cc9e8'],
    agua: ['#2b8a96', '#134656'],
    titulo: '#ffffff',
    subtitulo: '#e6f2fa',
    astro: 'sol',
    colorSol: '#ffd76a',
    estrellas: 0,
    nubes: true,
    luces: false,
  },
  atardecer: {
    cielo: ['#2b2a5a', '#ee8f5f'],
    agua: ['#2a5566', '#102838'],
    titulo: '#fff1e6',
    subtitulo: '#f3d3c2',
    astro: 'sol',
    colorSol: '#ff9a5c',
    estrellas: 0.3,
    nubes: true,
    luces: true,
  },
  noche: {
    cielo: ['#0d1526', '#1d3550'],
    agua: ['#14424a', '#0b1d2a'],
    titulo: '#dff3e8',
    subtitulo: '#9aa6bd',
    astro: 'luna',
    colorSol: '#dff3e8',
    estrellas: 0.6,
    nubes: false,
    luces: true,
  },
};
